export default {"src":"/_next/static/media/image2.e2949b47.svg","height":135,"width":198,"blurWidth":0,"blurHeight":0};